import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SickLeaveListService } from '../services/sick-leave-list.service';
import { HrccService } from '../services/hrcc.service';
import { InvestigationService } from '../services/investigation.service';
import { Angular5Csv } from 'angular5-csv/Angular5-csv';
import { mapChildrenIntoArray } from '@angular/router/src/url_tree';

@Component({
  selector: 'app-sick-leave-list',
  templateUrl: './sick-leave-list.component.html',
  styleUrls: ['./sick-leave-list.component.css']
})
export class SickLeaveListComponent implements OnInit {

  public exportToCsv;
  public busy: boolean;
  public keys = [];

  public allocateTo = {
    allocateToName: '',
    allocateToRole: 'managedByHRAdmin'
  };


  public selectAllFlag: boolean;
  public p: number;
  public column: string;
  public direction: number;
  public isDesc: boolean;
  public updatedHrExpert: any;
  public editFlagForHr: boolean;
  public editFlagForExpert: boolean;
  public currentIndexOfHr: number;
  public currentIndexOfExpert: number;
  public allocateToName: string;
  public hrFilterFlag: boolean;
  public expertFilterFlag: boolean;
  public issueFilterFlag: boolean;
  public nameFilterFlag: boolean;
  public csvFilterFlag: boolean;
  public csvGenerated: boolean;
  public filterLeaveListTerm: string;
  public defaultFilters;// ['To be checked', 'On hold'];
  public hrStatusFilterList = ['To be checked', 'No check required', 'Justified', 'Unjustified', 'On hold', 'Corrected in PSFT'];
  public expertStatusFilterList = ['To be checked', 'No check required', 'Justified', 'Notify N+1', 'On hold'];
  public issuesFilterList =
    [
      // '3+ doctors',
      'Dates mismatch',
      'Invalid reason',
      'Potential photocopy',
      'Unrecognized signature',
      // 'Absence covering rejected holidays',
      // 'Coincides with event',
      'No signature detected',
      'Doctor 3 days after',
      'No OCR Dates',
      'No Certificate Present'
    ];
  public hrFilterList = [];

  filterObject = {
    hrStatus: [],
    expertStatus: [],
    issues: [],
    hrName: []
  }
  filterString = '|||';

  public outputListForVariousFilters = [];// ['hr To be checked', 'expert To be checked', 'hr On hold', 'expert On hold'];
  public groupFilterValue: string;

  public listOfHR = [];
  public listOfExpert = [];
  public list = [];
  public sickLeaveList = [];

  public hrUnjustifiedCount = 0;
  public expertUnjustifiedCount = 0;
  public checkedCount = 0;
  public totalCount = 0;
  public noLeaveSelectedFlag: boolean;
  public noLeaveSelectedMsg: string;

  constructor(public sickLeaveListService: SickLeaveListService,
    public investigationService: InvestigationService,
    public hrccService: HrccService,
    public router: Router,
    public activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.defaultFilters = '';
    this.direction = 0;
    this.p = 1;
    this.column = 'CategoryName';
    this.selectAllFlag = false;
    this.isDesc = false;
    this.busy = true;
    this.keys = [];
    this.filterLeaveListTerm = '';
    if (sessionStorage.getItem('vf') === null || sessionStorage.getItem('vf') === '') {
      sessionStorage.setItem('vf', '');
    }
    else {
      this.filterObject = JSON.parse(sessionStorage.getItem('vf'));
      this.filterString = this.filterToString();
    }

    this.sickLeaveListService.getIrregularitiesList().subscribe(
      (res: any) => {
        if (res.status === 'success') {
          this.sickLeaveList = res.response;
          this.busy = false;
          for (let i = 0; i < this.sickLeaveList.length; i++) {
            this.sickLeaveList[i]['selected'] = false;
            let tempArray = this.sickLeaveList[i].issuetype.split(';');
            let tempArray2 = [];
            tempArray.forEach((item) => {
              if (item.trim() !== '') {
                tempArray2.push(item.trim());
              }
            });

            this.sickLeaveList[i]['typesOfErrorOrIssue'] = tempArray2;
            this.totalCount = this.sickLeaveList.length;
            if (this.sickLeaveList[i].statushradmin_desc === 'To be checked') {
              this.hrUnjustifiedCount += 1;
            }
            if (this.sickLeaveList[i].statusabsenceexpert_desc === 'To be checked') {
              this.expertUnjustifiedCount += 1;
            }
            delete this.sickLeaveList[i].issuetype;
          }
          this.list = this.sickLeaveList;
          this.changeList();
        } else {
          if (res.status === 'fail') {
            this.busy = false;
            this.sickLeaveList = [];
            this.list = this.sickLeaveList;
          }
        }
      },
      (err) => {
        if (err.status === 401) {
          alert('You are either unauthorized or your seesion is expired!');
          this.sickLeaveListService.redirectToSAB();
        }
        this.busy = false;
        this.sickLeaveList = [];
        this.list = this.sickLeaveList;
      });
    this.sickLeaveListService.getHrAdminExpertList().subscribe(
      (res: any) => {
        this.listOfHR = [];
        this.listOfExpert = [];

        this.listOfHR = this.matchArray(res.response, "HRADMIN");
        this.listOfExpert = this.matchArray(res.response, "ABSENCEEXPERT");

      },
      (err) => {
        if (err.status === 401) {
          alert('You are either unauthorized or your seesion is expired!');
          this.sickLeaveListService.redirectToSAB();
        }
      }
    );

    this.noLeaveSelectedFlag = false;
    this.noLeaveSelectedMsg = '';

    this.hrFilterFlag = true;
    this.expertFilterFlag = true;
    this.issueFilterFlag = true;
    this.nameFilterFlag = true;

    this.editFlagForHr = false;
    this.editFlagForExpert = false;
    this.csvFilterFlag = true;
    this.csvGenerated = false;
  }

  matchArray(res, role) {
    let array = [];
    for (let i = 0; i < res.length; i++) {
      let temp = { empid: "", name: "", role: "" };
      temp.empid = res[i].empid;
      temp.name = res[i].name;
      temp.role = role;
      array.push(temp);
    }
    return array;
  }

  processFilterObject(array, itemValue) {
    if (itemValue !== null && itemValue.trim() !== '') {
      if (array.indexOf(itemValue) !== -1) {
        array.splice(array.indexOf(itemValue), 1);
        return array;
      }
      else {
        array.push(itemValue);
        return array;
      }
    }
    return array;
  }

  filterToString() {
    return this.filterObject.hrStatus.toString()
      + '|' + this.filterObject.expertStatus.toString()
      + '|' + this.filterObject.issues.toString()
      + '|' + this.filterObject.hrName.toString();
  }

  updateList(itemValue, type) {
    let temp = [];
    if (type === 'hradmin') {
      temp = this.processFilterObject(this.filterObject.hrStatus, itemValue);
      this.filterObject.hrStatus = temp;
    } else if (type === 'expert') {
      temp = this.processFilterObject(this.filterObject.expertStatus, itemValue);
      this.filterObject.expertStatus = temp;
    } else if (type === 'issue') {
      temp = this.processFilterObject(this.filterObject.issues, itemValue);
      this.filterObject.issues = temp;
    } else {
      if (type === 'hrname') {
        temp = this.processFilterObject(this.filterObject.hrName, itemValue);
        this.filterObject.hrName = temp;
      }
    }
    sessionStorage.setItem('vf', JSON.stringify(this.filterObject));
    this.filterString = this.filterToString();
  }

  editManagedByHrExpert(item, updateForm, role, absenceid, revisionkey) {
    const ids = [];
    let temp;
    if (role === 'HrAdmin') {
      temp = this.listOfHR.find(i => i.empid === updateForm.value.hrListOption);
      this.editFlagForHr = false;
    } else {
      if (role === 'Expert') {
        temp = this.listOfExpert.find(i => i.empid === updateForm.value.expertListOption);
        this.editFlagForExpert = false;
      }
    }
    const obj = {
      'absenceid': absenceid,
      'revisionkey': revisionkey
    };
    ids.push(obj);

    this.sickLeaveListService.updateHrExpertAllocation(ids, temp, 'userid')
      .subscribe(
        (res) => {
          if (role === 'HrAdmin') {
            item.hrname = temp.name;
            item.allocatedtohradmin = temp.empid;
          } else {
            if (role === 'Expert') {
              item.expertname = temp.name;
              item.allocatedtoexpert = temp.empid;
            }
          }
          item.revisionkey++;
          alert('Irrgularity with Absence ID ' + item.absenceid + ' updated successfully!');
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
        }
      );

  }

  selectAll() {
    for (let i = 0; i < this.sickLeaveList.length; i++) {
      this.sickLeaveList[i]['selected'] = this.selectAllFlag;
    }
    this.list = this.sickLeaveList;
  }

  checkIfAllSelected() {
    this.selectAllFlag = this.sickLeaveList.every((item: any) => {
      return item.selected === true;
    });
    this.list = this.sickLeaveList;
  }

  sortBy(property: string) {
    this.isDesc = !this.isDesc;
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
  };

  multipleAllocateTo(hrExpert) {
    let temp;
    const ids = [];
    if (hrExpert.allocateToFlag === 'managedByHRAdmin') {
      temp = this.listOfHR.find(item => item.empid === hrExpert.allocatedTo);
    } else {
      if (hrExpert.allocateToFlag === 'managedByExpert') {
        temp = this.listOfExpert.find(item => item.empid === hrExpert.allocatedTo);
      }
    }
    this.noLeaveSelectedFlag = false;
    for (let i = 0; i < this.sickLeaveList.length; i++) {
      if (this.sickLeaveList[i]['selected'] === true) {
        this.noLeaveSelectedFlag = true;
        break;
      }
    }
    if (this.noLeaveSelectedFlag === false) {
      alert('Please select one or more checkbox to allocate!');
      return;
    }
    if (this.allocateTo.allocateToName === '' || this.allocateTo.allocateToName === null) {
      alert('Please select HR/Expert Name!');
      return;
    }
    for (let i = 0; i < this.sickLeaveList.length; i++) {
      if (this.sickLeaveList[i]['selected'] === true) {
        const obj = {
          'absenceid': this.sickLeaveList[i].absenceid,
          'revisionkey': this.sickLeaveList[i].revisionkey
        };
        ids.push(obj);
        this.sickLeaveList[i][this.allocateTo.allocateToRole] = this.allocateTo.allocateToName;
      }
    }

    this.sickLeaveListService.updateHrExpertAllocation(ids, temp, 'userid')
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            for (let i = 0; i < this.sickLeaveList.length; i++) {
              if (this.sickLeaveList[i]['selected'] === true) {
                if (temp.role === 'HRADMIN') {
                  this.sickLeaveList[i].hrname = temp.name;
                  this.sickLeaveList[i].allocatedtohradmin = temp.empid;
                } else {
                  if (temp.role === 'ABSENCEEXPERT') {
                    this.sickLeaveList[i].expertname = temp.name;
                    this.sickLeaveList[i].allocatedtoexpert = temp.empid;
                  }
                }
                this.sickLeaveList[i].revisionkey++;
              }
            }
            this.list = this.sickLeaveList;
            alert('Selected records allocated successfully to ' + temp.name);
          }
          if (res.status === 'fail') {
            alert('Records updation failed!');
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
        }
      );
  }

  toHRCCView(item) {
    this.hrccService.sickLeave = item;
    // localStorage.setItem('obj', JSON.stringify(item));
    this.router.navigate(['sll/hrccView', item.absenceid, item.empid]);
  }

  toInvestigationView(item) {
    this.investigationService.sickLeave = item;
    // localStorage.setItem('obj', JSON.stringify(item));
    this.router.navigate(['sll/investigationView', item.absenceid, item.empid]);
  }

  exportToCSV() {
    const keys = Object.keys(this.sickLeaveList[0]);

    console.log(this.sickLeaveList);

    this.exportToCsv = this.sickLeaveList.filter((item) => {
      return item.csvgenerated === false || item.csvgenerated === null;
    });

    if (this.exportToCsv.length === 0) {
      alert('All records are already exported to CSV!');
      return;
    }

    const options = {
      fieldSeparator: ';',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      useBom: true,
      noDownload: false,
      headers: keys,
      column: false,
      css: ''
    };

    const csvName = 'Report' + new Date();
    let tempArray = [];

    this.exportToCsv.forEach(element => {
      let id = {
        'absenceid': element.absenceid,
        'revisionkey': element.revisionkey,
        'csvgenerated': true
      };
      tempArray.push(id);
    });

    this.sickLeaveListService.updateHrExpertAllocation(tempArray, [], '')
      .subscribe(
        (res) => {
          new Angular5Csv(this.exportToCsv, csvName, options);
          this.sickLeaveList.forEach(element => {
            if (element.csvgenerated === false || element.csvgenerated === null) {
              element.csvgenerated = true;
            }
          });
          this.list = this.sickLeaveList;
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
        }
      );
  }


  changeList() {
    if (this.csvGenerated === true) {
      let temp = [];
      for (let i = 0; i < this.sickLeaveList.length; i++) {
        if (this.sickLeaveList[i].csvgenerated === true) {
          temp.push(this.sickLeaveList[i]);
        }
      }
      this.sickLeaveList = temp;
    } else {
      this.sickLeaveList = this.list;
    }
  }

  checkNull(item) {
    if (item === null) {
      return false;
    } else {
      if (item.trim() === '') {
        return false;
      }
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/sick-leave-list/sick-leave-list.component.ts